module.exports = __webpack_public_path__ + "img/UserValidSettings.460e562f.svg";